import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { formatErr } from "../lib/constants";
import CorrectionList from "../components/CorrectionList";

const TABS = [
  { code: "BEKLIYOR", label: "Bekleyen" },
  { code: "ONAYLANDI", label: "Onaylanan" },
  { code: "REDDEDILDI", label: "Reddedilen" },
];

export default function Corrections() {
  const [tab, setTab] = useState("BEKLIYOR");
  const [items, setItems] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [busyId, setBusyId] = useState(null);

  const load = () => api.get("/corrections", { params: { status: tab } }).then((r) => setItems(r.data));
  useEffect(() => { api.get("/hotels").then((r) => setHotels(r.data)); }, []);
  useEffect(() => { load(); }, [tab]);

  const hotelName = (c) => hotels.find((h) => h.code === c)?.name || c;

  const act = async (c, approve) => {
    setBusyId(c.id);
    try {
      await api.post(`/corrections/${c.id}/${approve ? "approve" : "reject"}`);
      toast.success(approve ? "Onaylandı, puantaj güncellendi" : "Talep reddedildi");
      load();
    } catch (e) { toast.error(formatErr(e)); }
    setBusyId(null);
  };

  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase mb-5 text-glow-sm">Düzeltme Talepleri</h1>
      <div className="flex gap-2 mb-4">
        {TABS.map((t) => (
          <button key={t.code} data-testid={`corr-tab-${t.code}`} onClick={() => setTab(t.code)}
            className={`px-4 py-1.5 rounded-full font-mono text-[11px] uppercase tracking-wider border transition ${tab === t.code ? "border-cyan-400 text-cyan-200 bg-cyan-500/15" : "border-slate-700 text-slate-400 hover:border-cyan-500/40"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="glass-card hud-corners p-4">
        <CorrectionList items={items} hotelName={hotelName} busyId={busyId}
          onApprove={(c) => act(c, true)} onReject={(c) => act(c, false)} />
      </div>
    </div>
  );
}
